import { render, staticRenderFns } from "./FavoriteSalesmanItem.vue?vue&type=template&id=04d81d2a"
import script from "./FavoriteSalesmanItem.vue?vue&type=script&lang=js"
export * from "./FavoriteSalesmanItem.vue?vue&type=script&lang=js"
import style0 from "./FavoriteSalesmanItem.vue?vue&type=style&index=0&id=04d81d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports